import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, inject, Input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectService } from "@domain/project/project.service";
import { UserService } from "@domain/user/user.service";
import { filter, map, Observable } from "rxjs";
import { Breakpoints } from "../../../../../styles/breakpoints";

interface Option {
  value: string;
  label: string;
}

@Component({
  selector: "app-checklist-item-single-choice",
  templateUrl: "./checklist-item-single-choice.component.html",
  styleUrls: ["./checklist-item-single-choice.component.scss"],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [UiKitModule, ReactiveFormsModule],
  standalone: true,
})
export class ChecklistItemSingleChoiceComponent {
  private userService = inject(UserService);
  private projectService = inject(ProjectService);
  private breakpointObserver = inject(BreakpointObserver);

  protected isPhone = toSignal(this.breakpointObserver.observe(Breakpoints.mobile).pipe(map((result) => result.matches)), {
    initialValue: false,
  });

  protected isReadOnlyUser$: Observable<boolean>;
  protected hasWritePermission$: Observable<boolean | undefined>;

  @Input()
  label!: string;

  @Input()
  subLabel!: string;

  @Input()
  groupName!: string;

  @Input()
  options!: Option[];

  @Input()
  disabled: boolean = true;

  constructor() {
    this.isReadOnlyUser$ = this.userService.user$.pipe(map((user) => user.readOnlyAccess));
    this.hasWritePermission$ = this.projectService.hasUserWritePermission$.pipe(
      filter((val): val is boolean => val !== undefined),
    );
  }
}
